





































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSTable from '@/components/AMSTable.vue';
import AMSDialog from '../../../components/AMSDialog.vue';
import AMSProductSelector from '@/components/AMSProductSelector.vue';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import AMSProductImg from '@/components/AMSProductImg.vue';
import request from '@/utils/request';
import { emptyRule, selectEmptyRule } from '@/utils/rules';
import { AppStore } from '@/store/modules/app';
import moment from 'moment';
import Utils from '@/utils/utils';

import { allStaff } from '@/api/staff';
import { getCustomer } from '@/api/customer';
import { customerNoPermissionList } from '@/api/customer';
import { addOrEditMaterials, getMaterialDetail, cancelMaterials } from '@/api/materials';

interface Product {
  productId?: string;
  quantity?: number;
}
interface Form {
  id?: string;
  number?: string;
  applicantId?: Number;
  selectedCustomerType?: string;
  customerName?: string;
  customerPhone?: string;
  items?: Product[];
  customerId?: string;
  deliveryAddressId?: string;
}

@Component({
  components: {
    'ams-table': AMSTable,
    'ams-product-selector': AMSProductSelector,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-product': AMSProduct,
    'ams-dialog': AMSDialog
  }
})
export default class EditMaterials extends Vue {
  breadcrumbsItems = [
    {
      text: '营销管理',
      disabled: false,
      href: '/materials'
    },
    {
      text: '物料申请',
      disabled: false,
      href: '/materials'
    },
    {
      text: this.isEdit() ? '修改物料申请单' : '新增物料申请单',
      disabled: true
    }
  ];
  form: Form = { selectedCustomerType: 'NewCustomer' ,customerPhone:'',customerName:''};
  staffList: Array<any> = [];
  customerTypeList: Array<any> = [{ value: 'NewCustomer', text: '新客户' }, { value: 'OldCustomer', text: '老客户' }, { value: 'None', text: '无' }];
  products: Array<Object> = [{}];
  deliveryAddresses: Array<any> = [{ isChecked: true }];
  rules = {
    applicantId: [selectEmptyRule('申请人')],
    selectedCustomerType: [selectEmptyRule('客户类型')],
    reason: [emptyRule('备注')]
  };
  addloading: Boolean = false;
  requestLoading: Boolean = false;
  isSaving = false;
  valid: boolean = true;
  reason: string = '';
  productHeaders = [
    { text: '序号', value: 'number', isSort: true, sortable: false },
    {
      text: '商品',
      value: 'name',
      render: (h: Function, param: any) => {
        return h(AMSSelectedProduct, {
          props: {
            items: param,
            selectedItems: this.products,
            isMoreBtn: true
          },
          on: {
            select: (value: Array<object>) => {
              this.products.splice(param.index, 1, ...value);
            },
            autoComplete: (value: Object) => {
              this.products.splice(param.index, 1, value);
            }
          }
        });
      },
      sortable: false
    },
    {
      text: '容量',
      align: 'right',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product ? param.row.product.capacity || '' : param.row.capacity || ''}`);
      },
      width: 120
    },
    {
      text: '单价',
      align: 'right',
      sortable: false,
      value: 'price',
      render: (h: any, param: any) => {
        return h('div', `${param.row.product ? param.row.product.orderPrice || '' : param.row.orderPrice || ''}`);
      }
    },
    {
      text: '数量',
      value: 'quantity',
      sortable: false,
      isInputNumber: {
        type: 'stockQuantity'
      }
    },
    { text: '操作', value: 'actions', isActions: true, align: 'center' }
  ];
  regionApi: string = '/api/System/Region/Tree';
  deleteAddressIndex: number | null = null;
  showDialog: boolean = false;
  confirmType: string = '';
  customerList: Array<any> = [];
  search: string = '';
  showSearch: boolean = false;
  showClientName: boolean = true;
  showClientPhone: boolean = true;
  clientName = this.form.customerName || '';

  get totalProducts() {
    return this.products.filter((p: any) => p.id).length;
  }
  get totalQuantity(): number {
    return this.products
      .map((item: any) => {
        return parseInt(item.quantity);
      })
      .filter((f: any) => {
        return f;
      })
      .reduce(this.plus, 0);
  }
  get isNoProduct() {
    let filters = this.products.filter((p: any) => {
      return p.id;
    });
    return filters.length == 0;
  }
   get phoneRule() {
    if (this.form.customerPhone && !/^1[3-9][0-9]{9}$/.test(this.form.customerPhone)) {
      return ['手机号格式不正确'];
    } else {
      return [];
    }
  }

  get isNoQuantity() {
    let error = false;
    this.products.forEach((p: any) => {
      if (p.id && !p.quantity) {
        error = true;
      }
    });
    return error;
  }
  get enableSubmitButton() {
    return this.reason != '' && this.reason.length <= 50;
  }
  get customerTypeRule() {
    if (!this.form.selectedCustomerType) {
      return ['客户类型不能为空'];
    } else {
      return [];
    }
  }
  get initDefaultAddress() {
    let defaultIndex = null;
    this.deliveryAddresses &&
      this.deliveryAddresses.forEach((a: any, idx: number) => {
        if (a.isChecked) {
          defaultIndex = idx;
        }
      });
    return defaultIndex;
  }


  get addressHeaders() {
    return [
      {
        text: '',
        value: 'isChecked',
        width: 80,
        render: (h: Function, param: any) => {
          return h('v-radio', {
            props: {
              value: param.index
            },
            on: {
              change: (value: any) => {
                this.setDefaultAddress(value);
              }
            }
          });
        }
      },
      {
        text: '收货人',
        value: 'name',
        width: 280,
        align: 'left',
        inputField: this.form.selectedCustomerType !== 'OldCustomer' ? { maxlength: 20 } : ''
      },
      {
        text: '省市区',
        value: 'regionId',
        align: 'left',
        render:
          this.form.selectedCustomerType !== 'OldCustomer'
            ? (h: Function, param: any) => {
                return h(AMSProduct, {
                  props: {
                    menuVisible: true,
                    needSelectLastOne: true,
                    needAllItem: false,
                    api: this.regionApi,
                    // value: param.row['region'] ? param.row['region'].id : null
                    value: param.row.regionId ? param.row.regionId : null
                  },
                  on: {
                    input: (value: any) => {
                      this.inputHandler(value, param);
                    }
                  }
                });
              }
            : (h: any, param: any) => {
                return h('div', param.row.region && param.row.region.fullName);
              }
      },
      { text: '详细地址', value: 'address', align: 'left', width: 500, inputField: this.form.selectedCustomerType !== 'OldCustomer' ? { maxlength: 50 } : '' },
      { text: '手机号', value: 'phone', align: 'left', inputField: this.form.selectedCustomerType !== 'OldCustomer' ? { maxlength: 11 /* ,rules:[telRule()] */ } : '' }
    ];
  }

  @Watch('search', { immediate: true, deep: true })
  onSearchChange(newValue: any, oldValue: any) {
    newValue && this.getCustomerList(newValue);
  }
  @Watch('showSearch', { immediate: true, deep: true })
  onShowSearchChange(newValue: any, oldValue: any) {
    if (newValue === 'false') {
      this.form.customerId = '';
    }
  }

  isEdit() {
    return this.$route.query.isEdit;
  }
  plus(a: number, b: number) {
    return a + b;
  }
  created() {
    this.getStaff();
    this.getFormData();
  }
  getFormData() {
    if (!this.$route.query.id) return;
    getMaterialDetail(this.$route.query.id.toString()).then((data: any) => {
      this.onCustomerTypeChange(data.selectedCustomerType);
      this.form = Object.assign({}, this.form, data);
      this.form.applicantId = data.applicant.id;
      this.products.splice(0, 1, ...data.items);
      this.deliveryAddresses.splice(0, 1, { ...data.deliveryAddress, isChecked: true });
      this.showSearch = false;
      this.form.customerId = data.customer ? data.customer.id : '';
      const customerId = data.customer ? data.customer.id : '';
      this.getCustomerAddress(customerId);
      this.clientName = data.customerName;
    });
  }
  getCustomerAddress(id: string) {
    if (!id) return;
    getCustomer(id).then((data: any) => {
      let checkedAddr = this.deliveryAddresses.filter((i: any) => i.isChecked)[0];
      let customerAddr = data.deliveryAddresses.map((p: any) => {
        if (p.id === checkedAddr.id) {
          p.isChecked = checkedAddr.isChecked;
        }
        return p;
      });
      this.deliveryAddresses = customerAddr;
    });
  }
  getStaff() {
    allStaff({ isActive: true }).then((data: any) => {
      this.staffList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
      if (!this.$route.query.id) {
        this.form.applicantId = this.$store.state.user.staffId;
      }
    });
  }
  submitApprove() {
    if ((this.$refs.form as any).validate()) {
      let err = false;
      // if (this.form.selectedCustomerType === 'NewCustomer' || this.form.selectedCustomerType === 'OldCustomer') {
        if (!this.form.customerName) {
          AppStore.ShowError('请填写客户名');
          return;
        } else if (!this.form.customerPhone) {
          AppStore.ShowError('请填写客户手机号');
          return;
        }
      // }
      if (this.isNoProduct) {
        AppStore.ShowError(`请选择商品`);
        return;
      } else if (this.isNoQuantity) {
        AppStore.ShowError(`商品数量不能为空`);
        return;
      } else {
        // if (this.form.selectedCustomerType !== 'None') {
          let filterDeliveryAddresses: any = [];
          filterDeliveryAddresses =
            this.deliveryAddresses &&
            this.deliveryAddresses!.map((c: any, i: number) => {
              for (var key of Object.keys(c!)) {
                if (!(c as any)[key]) {
                  delete (c as any)[key];
                }
              }
              if (Object.keys(c!).length === 0) {
                c = null;
              } else {
                if (!c!.name) {
                  err = true;
                  AppStore.ShowError('请填写收货人');
                }
                if (!c!.regionId) {
                  err = true;
                  AppStore.ShowError('请填写省市区');
                }
                if (!c!.address) {
                  err = true;
                  AppStore.ShowError('请填写收货详细地址');
                }
                if (!c!.phone) {
                  err = true;
                  AppStore.ShowError('请填写收货手机号');
                }
                if (c!.phone && !/^1[3-9][0-9]{9}$/.test(c!.phone)) {
                  err = true;
                  AppStore.ShowError('收货手机号格式不正确');
                }
              }
              return c;
            });
          if (
            filterDeliveryAddresses!.filter((p: any) => {
              return p !== null;
            }).length === 0
          ) {
            AppStore.ShowError('请填写收货地址');
            return;
          }
          if (
            filterDeliveryAddresses!.filter((p: any) => {
              return p.isChecked;
            }).length === 0
          ) {
            AppStore.ShowError('请选择一个收货地址');
            return;
          }
        // }
      }
      if (err) return;
      this.showDialog = true;
      this.confirmType = 'approve';
    }
  }
  cancelApprove() {
    this.showDialog = true;
    this.confirmType = 'cancel';
  }
  add(index: number, key: string) {
    this.products.splice(index + 1, 0, {});
  }
  remove(index: number, key: string) {
    this.products.splice(index, 1);
    if (this.products.length < 1) {
      this.products.push({});
    }
  }
  get dialogTitle() {
    switch (this.confirmType) {
      case 'approve':
        return '提交物料申请单';
      case 'cancel':
        return '取消物料申请单';
      default:
        return '请确认';
    }
  }
  textChange(list: Array<object>) {
    this.products = list;
  }
  addressChange(value: any) {
    this.deliveryAddresses = value;
    this.$emit('addressChange', this.deliveryAddresses);
  }
  inputHandler(value: any, param: any) {
    this.deliveryAddresses[param.index][param.keyName] = value;
    this.$emit('addressChange', this.deliveryAddresses);
  }
  setDefaultAddress(index: number) {
    this.deliveryAddresses.forEach((a: any, idx: number) => {
      a.isChecked = index == idx;
    });
  }
  sure() {
    switch (this.confirmType) {
      case 'cancel':
        if ((this.$refs.reasonForm as any).validate()) {
          let cancelForm = {
            orderId: this.form.id,
            remark: this.reason
          };
          this.requestLoading = true;
          cancelMaterials(cancelForm).then((data: any) => {
            this.showDialog = false;
            this.requestLoading = false;
            this.reason = '';
            this.confirmType = '';
            this.$router.push({ name: 'materials' });
            Utils.clearAllSearchPage(this.$route.name as string);
          });
        }
        break;
      case 'approve':
        if ((this.$refs.reasonForm as any).validate()) {
          let filterAddress = this.deliveryAddresses.filter((p: any) => p.isChecked);
          // filterAddress = this.form.selectedCustomerType === 'None' ? [] : filterAddress
          let formData = Object.assign({}, this.form, {
            deliveryAddressInput: filterAddress[0],
            remark: this.reason,
            items: this.products
              .filter((f: any) => f.id)
              .map((p: any) => {
                return { productId: p.productId ? p.productId : p.id, quantity: p.quantity };
              })
          });
          this.requestLoading = true;
          addOrEditMaterials(formData)
            .then((data: any) => {
              this.showDialog = false;
              this.requestLoading = false;
              this.reason = '';
              this.confirmType = '';
              AppStore.ShowSuccess(this.isEdit() ? '修改成功' : '新增成功');
              this.$router.push({ name: 'materials' });
              Utils.clearAllSearchPage(this.$route.name as string);
            })
            .catch((err: any) => {
              AppStore.ShowError(err.error.message);
              this.reason = '';
              this.requestLoading = false;
              this.showDialog = false;
            });
        }
        break;
      default:
        break;
    }
  }
  cancel() {
    (this.$refs.reasonForm as any).resetValidation();
    this.reason = '';
    this.showDialog = false;
    this.confirmType = '';
  }
  customerChange(v: any) {
    console.log('customerChange')
    if (v) {
      this.form.customerName = v.name;
      this.form.customerId = v.id;
      if (v.deliveryAddresses) {
        this.deliveryAddresses = v.deliveryAddresses;
      }
      if (v.phone) {
        this.form.customerPhone = v.phone;
      }
    } else {
      this.form.customerName = '';
      this.form.customerPhone = '';
      this.form.customerId = '';
      this.deliveryAddresses = [{ isChecked: true }];
    }
  }
  onCustomerTypeChange(v: any) {
    switch (v) {
      case 'NewCustomer':
        this.showSearch = false;
        this.showClientName = true;
        this.showClientPhone = true;
        break;
      case 'OldCustomer':
        this.showSearch = true;
        this.showClientName = true;
        this.showClientPhone = false;
        break;
      default:
        this.showSearch = false;
        this.showClientName = true;
        this.showClientPhone = true;
        break;
    }
    this.clientName = '';
    this.form.customerId = '';
    this.form.customerName = '';
    this.form.customerPhone = '';
    this.deliveryAddresses = [{ isChecked: true }];
    
  }
  getCustomerList(filter: string) {
    customerNoPermissionList({ isActive: true, filter: filter.split(' / ')[0], skipCount: 0, maxResultCount: 10 }).then((data: any) => {
      this.customerList = data.items.map((i: any) => {
        i.value = i.id;
        i.text = i.name;
        return i;
      });
    });
  }
  onCustomerNameFocus() {
    if (this.form.selectedCustomerType === 'OldCustomer') {
      this.showSearch = true;
    }
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
}
